// extracted by mini-css-extract-plugin
export default {"container":"FD-z","dimension":"GD-z","dimensionLabels":"HD-z"};